import imgSrc1 from './assets/01_Marian_Sang.jpg';
import imgSrc2 from './assets/02_Mary_Ann_Brookes.jpg';
import imgSrc3 from './assets/03_Jennifer_Dan_Horst.jpg';
import imgSrc4 from './assets/04_Laura_Pinkas.jpg';

export const config = [
  {
    imgSrc: imgSrc1,
    name: 'Marian Sang',
    companyName: 'Omagi Salon/Spa | Louisville, KY',
    review:
      'We have seen dramatic transformations in all areas of our company since we began coaching with Strategies and utilizing their Team-Based Business Model. Our retail was 11% of total sales. Since then, we have maintained 27% retail to total sales.',
  },
  {
    imgSrc: imgSrc2,
    name: 'Mary Ann Brookes',
    companyName: 'Brooks & Co. | Edwardsville, PA',
    review:
      'Thanks to Strategies and the Team-Based Business Model, we are doing things that I never dreamed possible for our company. By improving client retention, profitability, and productivity, we’ve been able to add meaningful benefits for our team every year.',
  },
  {
    imgSrc: imgSrc3,
    name: 'Jennifer & Dan Horst',
    companyName: 'Waxing the City - Tempe | Tempe, AZ',
    review:
      'We can FINALLY take a paycheck and put cash into cash reserves! But being able to give back to our team has been the most rewarding part of being profitable. We’ve been able to give healthy raises at least twice a year, invest in education, offer health, life, vision, and dental insurance, paid sick time, and paid time off.',
  },
  {
    imgSrc: imgSrc4,
    name: 'Laura Pinkas',
    companyName: 'Shine Hair Color & Design Studio , Columbia, SC',
    review:
      'Thanks to Strategies Coaching, we’ve transformed our company into a profitable, debt-free business that pays our team well and operates with financial freedom. We’ve improved productivity to 85–90%, boosted retail sales to 20–25%, and skill-certified our stylists, ensuring consistent quality',
  },
];
